// @flow
import { useState, useEffect } from 'react';
import { isEqual } from 'lodash';

export default function useFlux(mapper: () => any, stores: Array<any>) {
  const [mappedState, setMappedState] = useState(mapper());

  const observeStoreChanges = () => {
    const newState = mapper();

    if (!isEqual(mappedState, newState)) {
      setMappedState(newState);
    }
  };

  useEffect(() => {
    stores.forEach(store => store.subscribe(observeStoreChanges));

    return () => {
      stores.forEach(store => {
        store.unsubscribe(observeStoreChanges);

        if (store.flush) {
          store.flush();
        }
      });
    };
  }, []);

  return { ...mappedState };
}
